import { render } from "./HaplogroupProofBoard.vue?vue&type=template&id=c6c86dfe&scoped=true"
import script from "./HaplogroupProofBoard.vue?vue&type=script&lang=js"
export * from "./HaplogroupProofBoard.vue?vue&type=script&lang=js"

import "./HaplogroupProofBoard.vue?vue&type=style&index=0&id=c6c86dfe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6c86dfe"]])

export default __exports__